<template>
  <div class="eu-display_none" :id="id">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'EmdTippyTemplateHTML',
  props: {
    id: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>
